import { Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { PartyService } from '../../../services/party.service';
import { AutoComplete, AutoCompleteCompleteEvent, AutoCompleteModule, AutoCompleteSelectEvent } from 'primeng/autocomplete';
import { Party } from '../../../models/party';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';
import { CardModule } from 'primeng/card'
import { ButtonModule } from 'primeng/button';

@Component({
  selector: 'app-party-search',
  standalone: true,
  imports: [AutoCompleteModule, FormsModule, DatePipe, CardModule, ButtonModule],
  templateUrl: './party-search.component.html',
  styleUrl: './party-search.component.scss',
})
export class PartySearchComponent 
{

  @Input() placeholder: string = "Search";
  @Output() partySelected = new EventEmitter<Party>();
  @ViewChild('partySearchComponent') partySearchField?: AutoComplete;


  constructor
  (
    public _partyService: PartyService
  )
  {
    
  }

  

  partySuggestions: Party[] = [];
  selectedParty? : Party;


  partySearch(event:AutoCompleteCompleteEvent )
  {
    //Update the suggestions to our query results
    this._partyService.searchParties(event.query)
    .then
    (
      parties => 
        {
          this.partySuggestions = parties;
        }
    )
  }

  async selectParty(event: AutoCompleteSelectEvent)
  {
    var party = await this._partyService.getParty(event.value.id);
    this.partySelected.emit(party);
  }


  partyDisplayName() : string
  {
      return this.selectedParty?.firstName + " " + this.selectedParty?.lastName ;
  }

  searchFor(input: string)
  {
    if(this.partySearchField)
    {
      this.partySearchField.writeValue(input);
      this.partySearchField.search(null,input,null);
    }
  }
}
